import { SVGProps } from 'react';

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.444 11.556h1.03l7.06-7.06-1.03-1.03-7.06 7.06zM0 13V9.93L9.533.416q.217-.198.479-.307.261-.108.55-.108t.56.108.47.325l.993 1.011q.216.2.316.47a1.56 1.56 0 0 1 0 1.092 1.35 1.35 0 0 1-.316.479L3.069 13zm9.01-9.01-.506-.523 1.03 1.029z"
      fill="currentColor"
    />
  </svg>
);
export default SVGComponent;
